import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M19 12v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-14a2 2 0 0 1 2 -2h7l5 5v4.25","key":"svg-1"}]]

const IconInvoice = createReactComponent('outline', 'invoice', 'Invoice', __iconNode);

export default IconInvoice;